import { ComponentProps, FC, ReactNode } from 'react';
import CameraIcon from '../../../assets/icons/camera.svg?react';
import styles from './ImageInput.module.css';
import CloseIcon from '../../../assets/icons/close.svg?react';
import { SelectedImage } from '../types';
import { MAX_FILES_PER_QUESTION } from '../../../services/inspection';
import { FormattedMessage, useIntl } from 'react-intl';

export interface AddPhotoButtonTextProps {
  children?: ReactNode;
}

export const AddPhotoButtonText: FC<AddPhotoButtonTextProps> = ({
  children,
}) => (
  <label className={styles.addPhoto}>
    {children}
    <CameraIcon className={styles.icn} />
    <FormattedMessage tagName="span" id="Photo.Add" />
  </label>
);

export interface FileInputProps
  extends Pick<ComponentProps<'input'>, 'onChange'> {}

export const HiddenImageInput: FC<FileInputProps> = (props) => (
  <input
    className={styles.file}
    multiple={MAX_FILES_PER_QUESTION > 1}
    type="file"
    name="file"
    accept="image/png, image/jpeg"
    data-testid="upload-image"
    {...props}
  />
);

export interface ImageProps {
  image: SelectedImage;
  onClose: () => void;
}

export const Image: FC<ImageProps> = ({ image, onClose }) => {
  const { $t } = useIntl();
  return (
    <div className={styles.imageContainer}>
      <div
        className={styles.imageClose}
        onClick={onClose}
        title={$t({ id: 'Photo.Remove' })}
      >
        <CloseIcon className={styles.icn} />
      </div>
      <img className={styles.image} src={image.src} alt={image.file.name} />
    </div>
  );
};
